<template>
    <span class="renderer">
        <router-link :to="link">
            <ProfileIcon :icon="object.meta.icon" class="mr-2" style="font-size: .90em" />
            <span class="name">{{ object.meta.name }}</span>
        </router-link>
    </span>
</template>

<script>
    import Utils from '@/services/utils.js'
    import ProfileIcon from './ProfileIcon.vue';
    import {useDvFlagAccess} from "../../services/featureFlag";

    export default {
    name: "profilerenderer",
    computed: {
        link() {
            if (useDvFlagAccess("beepiz-profile-can:update")) {
                return "/configurations/profiles/" + this.object.profileId;
            }
            else {
                return "";
            }
        }
    },
    props: ["object"],
    components: { ProfileIcon }
}
</script>

<style lang="scss" scoped>

</style>
